import { FaEdit } from "react-icons/fa"

export default function ImagePreviewGrid({ imageUrls, onClick, onEditClick, gridCols = "grid-cols-3" }) {
  return (
    <div className={`grid ${gridCols} grow w-full px-6`}>
      {imageUrls && Object.keys(imageUrls).map((key, index) => {
        return(
          <div
            className="flex flex-col h-full items-center justify-center"
            key={key}
          >
            <div
              className="w-[20vw] h-[20vw] rounded mb-1"
              onClick={() => onClick(key)}
              data-testid={`photo-${key}`}
            >
              <img src={imageUrls[key]} alt="Preview" className="w-full h-full object-cover rounded" />
            </div>
            <div className="flex flex-col items-center text-xs text-center my-1">
              {key}
              <FaEdit
                className="text-sm my-0.5"
                onClick={() => onEditClick(index)}
                data-testid={`edit-photo-${key}`}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
